<script>
import {LoanBankAccount} from "@/models/LoanPayment/LoanBankAccount";
import {BankAccountStatus} from "@/models/BankAccountStatus";

export default {
  name: "BankAccountSelectItem",
  computed: {
    BankAccountStatus() {
      return BankAccountStatus
    }
  },
  props: {
    bankAccount: {
      type: LoanBankAccount,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<template>
  <div
      @click="$emit('click', bankAccount)"
      :class="{'bank-account-item-active': !active, 'shadow-md': active}"
      class="bank-account-item border-1 flex gap-3 mb-2 items-center justify-between p-5 rounded-lg">
    <div class="bank-status">
      <em class="fas fa-circle" :class="{
          'text-danger': bankAccount.verified !== BankAccountStatus.VERIFIED,
          'text-success': bankAccount.verified === BankAccountStatus.VERIFIED
        }"></em>
    </div>
    <div class="bank-account flex-1">
      <div>{{bankAccount.bank}}</div>
      <div>{{bankAccount.clabe}}</div>
    </div>
    <em v-if="active" class="fas fa-edit"></em>
  </div>
</template>

<style scoped>
.bank-account-item-active {
  background-color: #EFEFEF;
  border: 1px solid #CCC;
}
.bank-account-item:hover {
  background-color: #f1f0f0;
}
</style>